import * as React from "react";
import type { SVGProps } from "react";
const SvgBurgerMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      fillRule="evenodd"
      d="M3 6.52c0-.287.235-.52.525-.52h12.95c.29 0 .525.233.525.52 0 .289-.235.522-.525.522H3.525A.523.523 0 0 1 3 6.52m0 3.47c0-.288.235-.521.525-.521h12.95c.29 0 .525.233.525.52s-.235.522-.525.522H3.525A.523.523 0 0 1 3 9.99m.525 2.968A.523.523 0 0 0 3 13.48c0 .288.235.521.525.521h12.95c.29 0 .525-.233.525-.52a.523.523 0 0 0-.525-.522z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBurgerMenu;
